import { render } from "./MoldDataBoard.vue?vue&type=template&id=057855c7&scoped=true"
import script from "./MoldDataBoard.vue?vue&type=script&lang=js"
export * from "./MoldDataBoard.vue?vue&type=script&lang=js"

import "./MoldDataBoard.vue?vue&type=style&index=0&id=057855c7&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057855c7"]])

export default __exports__